import { X, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SelectionToolbarProps {
  selectedCount: number;
  onClearSelection: () => void;
  onDeleteClick: () => void;
}

export function SelectionToolbar({
  selectedCount,
  onClearSelection,
  onDeleteClick,
}: SelectionToolbarProps) {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-primary text-primary-foreground animate-in slide-in-from-top-2 duration-200"
         style={{ paddingTop: 'max(0.75rem, env(safe-area-inset-top, 0px))' }}>
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 text-primary-foreground hover:bg-primary-foreground/20"
            onClick={onClearSelection}
          >
            <X size={20} />
          </Button>
          <span className="font-medium">
            {selectedCount} message{selectedCount > 1 ? "s" : ""} sélectionné{selectedCount > 1 ? "s" : ""}
          </span>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="h-10 w-10 text-primary-foreground hover:bg-primary-foreground/20"
          onClick={onDeleteClick}
        >
          <Trash2 size={20} />
        </Button>
      </div>
    </div>
  );
}
